import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "../../lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-prosigliere-blue text-pure-white hover:bg-prosigliere-blue/80",
        secondary:
          "border-transparent bg-almost-gold text-pure-white hover:bg-almost-gold/80",
        destructive:
          "border-transparent bg-red-500 text-pure-white hover:bg-red-600",
        success:
          "border-transparent bg-green-500 text-pure-white hover:bg-green-600",
        warning:
          "border-transparent bg-orange-500 text-pure-white hover:bg-orange-600",
        outline: "text-almost-black border-prosigliere-grey",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
